<div class="confirm-container" role="alertdialog" aria-labelledby="draft-confirm-title">
  <div class="confirm-header">
    <div class="icon-circle"><mat-icon>forward_to_inbox</mat-icon></div>
    <div>
      <h2 id="draft-confirm-title">Prepare the correction email draft?</h2>
      <p class="header-sub">
        Select which issues to include in the draft email. Only selected issues will be drafted and sent.
      </p>
    </div>
  </div>

  <div class="report-line" *ngIf="data?.vesselName || data?.eventName">
    <span class="vessel">{{ data.vesselName }}</span>
    <span *ngIf="data?.eventName">· {{ data.eventName }}</span>
    <span *ngIf="data?.reportDate">· {{ data.reportDate }}</span>
    <span class="chip" [class.chip-partial]="selectedCount < issues.length">
      {{ selectedCount }} of {{ issues.length }} selected
    </span>
    <span class="chip chip-stage" *ngIf="data?.reminderLevel">
      {{ data.reminderLevel === 1 ? '1st Notice' : 'Reminder ' + data.reminderLevel }}
    </span>
  </div>

  <div class="selection-bar" *ngIf="issues.length > 1">
    <mat-checkbox
      [checked]="allSelected"
      [indeterminate]="someSelected"
      (change)="toggleAll($event.checked)"
      color="primary"
      class="select-all-checkbox"
    >
      <span class="select-all-label">Select all issues ({{ selectedCount }}/{{ issues.length }})</span>
    </mat-checkbox>
    <span class="selection-hint" *ngIf="selectedCount < issues.length">
      {{ issues.length - selectedCount }} issue{{ issues.length - selectedCount === 1 ? '' : 's' }} excluded
    </span>
  </div>

  <ol class="issue-list" *ngIf="issues.length; else noIssues">
    <li
      class="issue"
      *ngFor="let issue of issues; let i = index"
      [class.unselected]="issue.selected === false"
      (click)="toggleIssue(issue, $event)"
    >
      <mat-checkbox
        [checked]="issue.selected !== false"
        (change)="onCheckboxChange(issue, $event)"
        (click)="$event.stopPropagation()"
        color="primary"
        class="issue-checkbox"
      >
      </mat-checkbox>
      <span class="issue-num">{{ i + 1 }}</span>
      <div class="issue-body">
        <div class="issue-title">
          <strong>{{ issue.label }}</strong>
          <span class="issue-section" *ngIf="issue.section">{{ issue.section }}</span>
          <span
            class="issue-count"
            *ngIf="issue.mail_count"
            [class.repeat]="issue.mail_count > 1"
            [title]="issue.mail_count > 1 ? 'Raised in earlier mails too' : 'Raised for the first time'"
          >
            {{ issue.mail_count > 1 ? ordinal(issue.mail_count) + ' mail' : 'New' }}
          </span>
          <span class="excluded-badge" *ngIf="issue.selected === false">Excluded</span>
        </div>
        <div class="issue-message" *ngIf="issue.message">{{ issue.message }}</div>
      </div>
    </li>
  </ol>
  <ng-template #noIssues>
    <p class="no-issues">No issues found for this report.</p>
  </ng-template>

  <div class="confirm-footer">
    <button type="button" class="btn btn-light hover-button back-btn" (click)="cancel()">
      <mat-icon>close</mat-icon> Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary hover-button apply-btn"
      [disabled]="selectedCount === 0"
      (click)="confirm()"
      cdkFocusInitial
    >
      <mat-icon>check</mat-icon> Yes{{ selectedCount ? ' (' + selectedCount + ')' : '' }}
    </button>
  </div>
</div>
